import { UserProvider } from '@auth0/nextjs-auth0/client';
import 'antd/dist/antd.css';
import Head from 'next/head';
import Script from 'next/script';
import { Provider } from 'react-redux';
import { useStore } from 'src/stores';
import { GlobalStyle } from 'themes/global-style';

import PageError from 'pages/404';
import { TRUEHITS_URL } from 'src/constants';

const MyApp = ({ Component, pageProps }) => {
  const store = useStore(pageProps.initialReduxState);

  if (pageProps.statusCode >= 400) {
    return (
      <Provider store={store}>
        <PageError />
      </Provider>
    );
  }

  return (
    <>
      <Head>
        <meta name='viewport' content='width=device-width, initial-scale=1' />
      </Head>
      <Provider store={store}>
        <UserProvider>
          <GlobalStyle />
          <Component {...pageProps} />
        </UserProvider>
      </Provider>
      <Script
        strategy='afterInteractive'
        type='text/javascript'
        src={`${TRUEHITS_URL}`}
      />
    </>
  );
};

export default MyApp;
